import { render, staticRenderFns } from "./PanelAdd.vue?vue&type=template&id=4ad71172&"
import script from "./PanelAdd.vue?vue&type=script&lang=js&"
export * from "./PanelAdd.vue?vue&type=script&lang=js&"
import style0 from "./PanelAdd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports